import { Container, IDestroyOptions } from "@pixi/display";
import { LanguageElement } from "./LanguageElement";
import { SettingsController } from "../controllers/SettingsController";
import { SettingsResourcesPackage } from "../resources/SettingsResourcesPackage";
import { Language } from "../../common/Language";
import { AudioManager } from "../../../audio/AudioManager";

export class LanguagePanel extends Container {
    private languageElements: Array<LanguageElement>;
    private lastSelectedLanguage: LanguageElement;

    private readonly paddingX = 50;
    private readonly paddingY = 30;

    public constructor(
        private readonly settingsResources: SettingsResourcesPackage,
        private readonly settingsController: SettingsController,
        currentLanguage: Language,
        private readonly audioManager: AudioManager
    ) {
        super();
        this.languageElements = new Array<LanguageElement>();
        const languages = [
            { locale: Language.English, texture: this.settingsResources.assets_settings_english_png },
            { locale: Language.Czech, texture: this.settingsResources.assets_settings_czech_png },
            { locale: Language.Spanish, texture: this.settingsResources.assets_settings_spain_png },
            { locale: Language.French, texture: this.settingsResources.assets_settings_france_png },
            { locale: Language.German, texture: this.settingsResources.assets_settings_germany_png },
            { locale: Language.Italian, texture: this.settingsResources.assets_settings_italy_png },
            { locale: Language.Japanese, texture: this.settingsResources.assets_settings_japan_png },
            { locale: Language.Polish, texture: this.settingsResources.assets_settings_polish_png },
            { locale: Language.Russian, texture: this.settingsResources.assets_settings_russia_png }
        ];
        for (let i = 0; i < languages.length; i++) {
            const element = new LanguageElement(
                languages[i].texture,
                this.settingsResources.assets_settings_shine_png,
                languages[i].locale,
                this.audioManager
            );
            element.x = (i % 3) * (element.width + this.paddingX);
            element.y = Math.floor(i / 3) * (element.height + this.paddingY);
            if (currentLanguage == languages[i].locale) {
                element.select();
                this.lastSelectedLanguage = element;
            }
            element.onSelectLanguage.add(this.onSelectLanguage, this);
            this.addChild(element);
            this.languageElements.push(element);
        }
    }

    private onSelectLanguage(element: LanguageElement): void {
        this.lastSelectedLanguage.unselect();
        this.lastSelectedLanguage = element;
        this.settingsController.changeLocalization(element.language);
    }

    public override destroy(options?: IDestroyOptions | boolean): void {
        this.languageElements.forEach(e => e.onSelectLanguage.remove(this.onSelectLanguage), this);
        super.destroy(options);
    }
}